// Etiqueta unificada de cliente: SIEMPRE el código antes del nombre.
// Uso: etiquetaCliente(cliente) -> "123456 - NOMBRE CLIENTE"
// El ID de Magento NO se muestra en el lugar del código Presea: el pago 568
// mostraba "12198 - RODRIGO CATIVA TOLOSA" y 12198 es el cliente de Magento,
// no un código de Presea (Martin, 25 ago 2026). Si la ficha no tiene código
// Presea se dice, y el ID Magento va aparte y rotulado.
export function etiquetaCliente(cliente) {
  if (!cliente) return '—'
  const nombre = cliente.nombre || ''
  if (cliente.codigo_presea) return nombre ? `${cliente.codigo_presea} - ${nombre}` : String(cliente.codigo_presea)
  const magento = cliente.codigo_magento ? ` · Magento ${cliente.codigo_magento}` : ''
  return nombre ? `${nombre} (sin código Presea${magento})` : '—'
}
